import { SET_USER_ROLES, SET_NEW_TOKEN, SET_USER_STATUS } from '../types/userTypes';

const initialState = {
    is_logintab: false,
    is_loggedin: false,
    refresh_token: '',
    token: '',
    user_id: '',
    user_name: '',
    full_name: '',
    profile_pic: '',
    email: '',
    roles: '',
    email_status: ''
}

export default function reducer(state = initialState, action) {
    switch (action.type) {
    case SET_USER_ROLES:
        return {
            ...state,
            roles: action.roles
        }
    case SET_NEW_TOKEN:
        return {
            ...state,
            token: action.token
        }
    case SET_USER_STATUS:
        return {
            ...state,
            email_status: action.status
        }
    default:
        return {
            ...state
        }
    }
}